import React from "react";

const IconMedium = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="feather feather-medium"
  >
    <title>Medium</title>
    <path d="M2.846 6.887a.41.41 0 0 0-.131-.342L.522 3.743V3.333h6.63l5.124 11.224L16.82 3.333h6.285v.41l-1.826 1.75a.246.246 0 0 0-.093.235v13.12a.246.246 0 0 0 .093.235l1.78 1.75v.41h-8.928v-.41l1.84-1.787c.18-.18.18-.233.18-.525V8.48l-5.124 13.08h-.693L5.166 8.48v8.753c-.049.376.074.755.338 1.033l2.393 2.906v.41H0v-.41l2.393-2.906c.264-.278.382-.657.338-1.033V6.887z"/>
  </svg>
);

export default IconMedium;
